import api from './api';
import { getConsultantIdentifier } from '../Redux/UsersDucks'
import ErrorService from './errorService';
import Swal from 'sweetalert2';


export const CustomerService = {
  updateCustomer: async (hubspotId, customer, contractId, InterviewId) => {
    try {

      const consultantIdentifier = getConsultantIdentifier();
      if (!consultantIdentifier) {
        throw new Error('Consultor. Se debe de ingresar en el sistema es requerido su rut.');
      }

      // Usar api.patch para la petición
      const response = await api.patch(`HubSpot/${hubspotId}`, {
        firstName: customer.firstName,
        lastName: customer.lastName,
        FechaNacimientoSinVerificar: new Date(customer.fechaNacimientoSinVerificar).toISOString().split("T")[0],
        address: customer.address,
        email: customer.email,
        phone: customer.phone,
        createdBy: consultantIdentifier,
        contractId,
        InterviewId
      });

      // Mostrar mensaje de éxito usando Swal
      Swal.fire({
        icon: 'success',
        title: '¡Éxito!',
        text: 'Se actualizó correctamente.',
        confirmButtonText: 'Aceptar',
      });

      return response.data;
    } catch (error) {
      ErrorService.handleApiError('Error al actualizar el cliente HubSpot:', error);
      throw error;
    }
  },

  insertHubspotDealId: async (requestBody) => {
    try {
      const response = await ErrorService.withTimeout(api.post('/HubSpot/inyecction/deal/insert', requestBody));

      // Mostrar mensaje de éxito
      Swal.fire({
        icon: 'success',
        title: '¡Éxito!',
        text: 'Se actualizó correctamente el negocio en HubSpot.',
        confirmButtonText: 'Aceptar',
      });

      return response.data;
    } catch (error) {
      // Manejar errores
      ErrorService.handleApiError('Error al enviar la actualizacion del negocio a HubSpot:', error);
      throw error;
    }
  },

  sendHubspotDealId: async (requestBody) => {
    try {

      //const requestBody = { dealHubspotId, contractId }

      const response = await ErrorService.withTimeout(api.post('/Contract/SaveHubspotDealId', requestBody));

      // Mostrar mensaje de éxito
      Swal.fire({
        icon: 'success',
        title: '¡Éxito!',
        text: 'Se guardó correctamente el ID del Negocio de HubSpot.',
        confirmButtonText: 'Aceptar',
      });

      return response.data;
    } catch (error) {
      // Manejar errores
      ErrorService.handleApiError('Error al enviar el ID del contrato a HubSpot:', error);
      throw error;
    }
  },

  createCustomerService: async (hubspotId, customer, contractId, interviewId) => {
    try {
      if (customer.createDate == null || customer.createDate == undefined || customer.createDate == "")
        customer.createDate = new Date()

      const consultantIdentifier = getConsultantIdentifier();
      if (!consultantIdentifier) {
        throw new Error('Consultor. Se debe de ingresar en el sistema es requerido su rut.');
      }
      const requestBody = {

        idCountry: customer.country,
        idDistrito: customer.comuna,
        idBranch: customer.sucursal,
        firstName: customer.firstName,
        lastName: customer.lastName,
        identifier: customer.rut,
        email: customer.email,
        telephone: customer.phone,
        address: customer.address,
        observations: customer.observations,
        create_At: customer.createDate,
        //update_At: "0001-01-01T00:00:00",
        idStatus: 1,
        hubspotID: hubspotId,
        idProvince: customer.provincia,
        idRegion: customer.region,
        idCategoria: customer.categoria,
        idEstadoCivil: customer.estadoCivil,
        idGenero: customer.genero,
        idNivelEducacional: customer.nivelEducacional,
        profesion: customer.profesion,
        tipoCliente: customer.rutPyme ? 2 : 1,
        claveUnica: customer.claveUnica,
        rutPyme: customer.rutPyme,
        nombrePyme: customer.nombrePyme,
        createdBy: consultantIdentifier,      // Add the consultant identifier here
        fechaNacimientoSinVerificar: new Date(customer.fechaNacimientoSinVerificar).toISOString().split("T")[0],
        contractId,
        interviewId
        // updateBy :consultantIdentifier,

      }
      const response = await ErrorService.withTimeout(api.post('/Customer', requestBody));

      // Mostrar mensaje de éxito usando Swal
      Swal.fire({
        icon: 'success',
        title: '¡Éxito!',
        text: 'Se creo correctamente el cliente.',
        confirmButtonText: 'Aceptar'
      });
      return response.data;
    } catch (error) {
      console.log(error)
      ErrorService.handleApiError('Error al crear al cliente en el Generador Contrato:', error);
      throw error;
    }

  },

  registrarAcreedores: async (data) => {
    try {
      const consultantIdentifier = getConsultantIdentifier();
      if (!consultantIdentifier) {
        throw new Error('Consultor. Se debe de ingresar en el sistema es requerido su rut.');
      }
      // Formateo del request body para enviar múltiples acreedores
      const requestBody = data


      // Llamada a la API para insertar los acreedores
      const response = await ErrorService.withTimeout(api.post('/Acreedores', requestBody));

      // Mostrar mensaje de éxito usando Swal
      Swal.fire({
        icon: 'success',
        title: '¡Éxito!',
        text: 'Los acreedores se han registrado correctamente.',
        confirmButtonText: 'Aceptar'
      });

      return response.data;
    } catch (error) {
      console.error("Error registrando acreedores:", error.message || error);
      throw error;
    }
  },
  addCausaContractValidate: async (data) => {
    try {
      const consultantIdentifier = getConsultantIdentifier();
      if (!consultantIdentifier) {
        throw new Error('Consultor. Se debe de ingresar en el sistema es requerido su rut.');
      }
      const requestBody = data
      requestBody.createdBy = consultantIdentifier

      const response = await ErrorService.withTimeout(api.post('/Causas/addCausaContractValidacion', requestBody));

      // Mostrar mensaje de éxito usando Swal
      Swal.fire({
        icon: 'success',
        title: '¡Éxito!',
        text: 'Causas registrada correctamente.',
        confirmButtonText: 'Aceptar'
      });

      return response.data;
    } catch (error) {
      console.error("Error registrando causas:", error.message || error);
      throw error;
    }
  },

  deleteCausaContractValidate: async (data) => {
    try {
      const consultantIdentifier = getConsultantIdentifier();
      if (!consultantIdentifier) {
        throw new Error('Consultor. Se debe de ingresar en el sistema es requerido su rut.');
      }
      const requestBody = data
      requestBody.createdBy = consultantIdentifier

      const response = await ErrorService.withTimeout(api.post('/Causas/deleteCausaContractValidacion', requestBody));

      return response.data;
    } catch (error) {
      console.error("Error eliminando causa:", error.message || error);
      throw error;
    }
  },

  causasContrato: async (requestBody) => {
    try {
      const consultantIdentifier = getConsultantIdentifier();
      if (!consultantIdentifier) {
        throw new Error('Consultor. Se debe de ingresar en el sistema es requerido su rut.');
      }

      // Llamada a la API para insertar las cuasas contrato
      const response = await ErrorService.withTimeout(api.post('/CausasContrato', requestBody));

      // Mostrar mensaje de éxito usando Swal
      Swal.fire({
        icon: 'success',
        title: '¡Éxito!',
        text: 'Las causas se han registrado correctamente.',
        confirmButtonText: 'Aceptar'
      });

      return response.data.causas;
    } catch (error) {
      console.error("Error registrando causas:", error.message || error);
      throw error;
    }
  },

  validarCausasContrato: async (data) => {
    try {
      const consultantIdentifier = getConsultantIdentifier();
      // if (!consultantIdentifier) {
      //  throw new Error('Consultor. Se debe de ingresar en el sistema es requerido su rut.');
      //}

      // Llamada a la API para guardar validacion de acreedor
      const response = await ErrorService.withTimeout(api.post('/CausasContrato/Validate', data));

      // Mostrar mensaje de éxito usando Swal
      Swal.fire({
        icon: 'success',
        title: '¡Éxito!',
        text: 'Validacion de causa registrada correctamente.',
        confirmButtonText: 'Aceptar'
      });

      return response.data;
    } catch (error) {
      console.error("Error registrando causa:", error.message || error);
      throw error;
    }
  },

  obtieneIdCliente: async (identifier) => {
    try {
      const response = await ErrorService.withTimeout(api.get(`/Customer/GetCustomerGC/${identifier}`));
      return response.data.id;
    } catch (error) {
      ErrorService.handleApiError("Error al obtener el ID del cliente:", error);
      throw error;
    }
  },

  obtieneCliente: async (identifier) => {
    try {
      const response = await ErrorService.withTimeout(api.get(`/Customer/GetCustomerGC/${identifier}`));
      return response.data.id;
    } catch (error) {
      ErrorService.handleApiError("Error al obtener el ID del cliente:", error);
      throw error;
    }
  },

  registarInfoComplementaria: async (formData) => {
    try {

      const customerId = await CustomerService.obtieneIdCliente(formData.identifier)

      // Construir el cuerpo de la solicitud basado en los datos del formulario.
      const requestBody = {
        customerId: customerId || null,
        identifier: formData.identifier || "",
        acreedores: formData.acreedores || "",
        aval: formData.aval || false,
        avalNombre: formData.avalNombre || "",
        instruccionesInmediatas: formData.instruccionesInmediatas || "",
        domicilios: formData.domicilios || "",
        expectativa: formData.expectativa || "",
        jsReferencia: formData.jsReferencia || "",
        patrimonio: {
          bienesMuebles: formData.patrimonio?.bienesMuebles?.map((bienMueble) => ({
            item: bienMueble.item || "",
            monto: bienMueble.monto || 0,
          })) || [],
          bienesInmuebles: formData.patrimonio?.bienesInmuebles?.map((bienInmueble) => ({
            item: bienInmueble.item || "",
            monto: bienInmueble.monto || 0,
          })) || [],
          derechosHereditarios: {
            madre: formData.patrimonio?.derechosHereditarios?.madre || false,
            padre: formData.patrimonio?.derechosHereditarios?.padre || false,
            herencia: formData.patrimonio?.derechosHereditarios?.herencia || false,
            otros: formData.patrimonio?.derechosHereditarios?.otros || false,
          },
          OtrosDetalle: formData.OtrosDetalle || "",
        },
      };


      // Llamada a la API usando un método con manejo de timeout.
      const response = await ErrorService.withTimeout(api.post("/Propiedades", requestBody));

      // Mostrar mensaje de éxito usando SweetAlert.
      Swal.fire({
        icon: "success",
        title: "¡Éxito!",
        text: "La información complementaria se ha registrado correctamente.",
        confirmButtonText: "Aceptar",
      });

      // Devolver la respuesta para posibles usos posteriores.
      return response.data;
    } catch (error) {
      // Manejo de errores.
      console.error("Error registrando información complementaria:", error.message || error);

      // Mostrar mensaje de error.
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Hubo un problema registrando la información. Por favor, intenta nuevamente.",
        confirmButtonText: "Aceptar",
      });

      // Propagar el error para manejo adicional si es necesario.
      throw error;
    }

  },

  createPayingCustomerService: async (payingCustomerData) => {
    try {
      const consultantIdentifier = getConsultantIdentifier();
      if (!consultantIdentifier) {
        throw new Error('Consultor. Se debe de ingresar en el sistema es requerido su rut.');
      }
      // Verificar si los datos están completos
      if (!payingCustomerData) {
        throw new Error('Los datos del cliente son requeridos.');
      }

      // Crear el cuerpo del request (requestBody)
      const requestBody = {
        id: payingCustomerData.id || 0,
        firstName: payingCustomerData.firstName || '',
        lastName: payingCustomerData.lastName || '',
        identifier: payingCustomerData.rut.replace(/[ .]/g, '') || '',
        email: payingCustomerData.email || '',
        idStatus: payingCustomerData.idStatus || 1, // Estado por defecto
        telephone: payingCustomerData.phone || '',
        address: payingCustomerData.address || '',
        observations: payingCustomerData.observations || '',
        idCountry: payingCustomerData.country || 0,
        idDistrito: payingCustomerData.comuna || 0,
        idRegion: payingCustomerData.region || 0,
        idTipoPersona: payingCustomerData.tipoCliente || 0,
        idGenero: payingCustomerData.genero || 0,
        idEstadoCivil: payingCustomerData.estadoCivil || 0,
        idProvince: payingCustomerData.provincia || 0,
        ocupacion: payingCustomerData.ocupacion || '',
        contractId: payingCustomerData.contractId || 0,
        rutPyme: payingCustomerData.rutPyme || '',
        nombrePyme: payingCustomerData.nombrePyme || '',
        createBy: consultantIdentifier
      };

      // Llamada al endpoint POST
      const response = await ErrorService.withTimeout(api.post('/PayingCustomer', requestBody));

      // Mostrar mensaje de éxito
      /*Swal.fire({
        icon: 'success',
        title: '¡Éxito!',
        text: 'Se agregó correctamente el cliente.',
        confirmButtonText: 'Aceptar',
      });*/

      return response.data;
    } catch (error) {
      // Manejar errores
      ErrorService.handleApiError('Error al agregar el cliente:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'No se pudo agregar el cliente. Inténtalo nuevamente.',
        confirmButtonText: 'Aceptar',
      });
      throw error;
    }
  },

  getCustomerByIdService: async (customerId) => {
    try {
      // Validar el ID del cliente
      if (!customerId) {
        throw new Error('El ID del cliente es requerido.');
      }

      // Realizar la solicitud GET
      const response = await ErrorService.withTimeout(api.get(`/Customer/${customerId}`));

      // Mostrar mensaje de éxito usando Swal
      Swal.fire({
        icon: 'success',
        title: '¡Cliente encontrado!',
        text: `Se recuperó la información del cliente con ID: ${customerId}.`,
        confirmButtonText: 'Aceptar',
      });

      // Retornar los datos del cliente
      return response.data;

    } catch (error) {
      // Manejar errores y mostrar mensaje
      ErrorService.handleApiError('Error al obtener la información del cliente:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'No se pudo recuperar la información del cliente. Inténtalo nuevamente.',
        confirmButtonText: 'Aceptar',
      });
      throw error;
    }
  },

  getCustomerByHubspotIdService: async (hubspotId) => {
    try {
      // Validar el ID del cliente
      if (!hubspotId) {
        throw new Error('El ID del cliente es requerido.');
      }

      // Realizar la solicitud GET
      const response = await ErrorService.withTimeout(api.get(`/Customer/hubspot/${hubspotId}`));

      // Mostrar mensaje de éxito usando Swal
      Swal.fire({
        icon: 'success',
        title: '¡Cliente encontrado!',
        text: `Se recuperó la información del cliente con ID: ${hubspotId}.`,
        confirmButtonText: 'Aceptar',
      });

      // Retornar los datos del cliente
      return response.data;

    } catch (error) {
      // Manejar errores y mostrar mensaje
      ErrorService.handleApiError('Error al obtener la información del cliente:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'No se pudo recuperar la información del cliente. Inténtalo nuevamente.',
        confirmButtonText: 'Aceptar',
      });
      throw error;
    }
  }

};



export default CustomerService;
